import { http } from '@/plugins/axios'

const testarBanco = () => {
    return http
        .get('health')
        .then(response => {
            return response.data
        })
        .catch((e) => console.log(e))
}

export default {
    testarBanco
}